import React, { useEffect } from "react";
// import TableView from "../../../CustomComponent/TableViewDash";
import TableView from "../../../CustomComponent/TableView";
import useStyles from "../../../../styles";
import { useState } from "react";
import { Button, withStyles, Tooltip, } from "@material-ui/core";
import { ReactComponent as DashboardIcon } from "../../../images/examimage/dashboard.svg";
import Typography from "@material-ui/core/Typography";
import { useNavigate } from "react-router-dom";
import KeyboardArrowRightIcon from "@material-ui/icons/KeyboardArrowRight";
import Exam from "../../Exam/ViewExam/Exam";
import IconButton from "@material-ui/core/IconButton";
import { ReactComponent as ResultIcon } from "../../../images/examimage/result.svg";
import { decryptData } from "../../../../crypto";
import axios from "axios";

function UpcomingExam({ dashboardData }) {
  const classes = useStyles();
  const navigate = useNavigate();
  const decryptedToken = decryptData(sessionStorage.getItem("token"));

  const [pageSize, setPageSize] = useState(25);
  const [onPage, setOnPage] = useState(0);
  const [page, setPage] = useState(0);
  const [rowCount, setRowCount] = useState("");
  const [examData, setExamData] = useState([]);
  
  const handlePageChange = (newPage) => {
    setPage(newPage);
    setOnPage(newPage);
  };

  const handlePageSizeChange = (newPageSize) => {
    setPageSize(newPageSize);
    setPage(0);
    setOnPage(0);
  };

  const fetchData = async (pageNumber, size) => {
    if (!Number.isFinite(pageNumber) || !Number.isFinite(size)) return;

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/v1/b2b/dashbord/client?page=${
          pageNumber + 1
        }&limit=${size}`,
        {
          headers: {
            Authorization: `Bearer ${decryptedToken}`,
          },
        }
      );
      console.log("Exam data response:", response.data);
      if (response.data && response.data.exam) {
        setExamData(response.data.exam);
        setRowCount(response.data.count);
      }
    } catch (error) {
      console.error("Error fetching exam data: ", error);
    }
  };

  useEffect(() => {
    if (onPage !== undefined && pageSize !== undefined) {
      fetchData(onPage, pageSize);
    }
  }, [onPage, pageSize]);

  // Fallback to dashboardData if API call fails or for initial load
  const displayData = examData.length > 0 ? examData : (dashboardData || []);

  useEffect(() => {
    if (!examData.length && dashboardData) {
      setRowCount(dashboardData.length);
    }
  }, [dashboardData, examData]);
  

  const style = [
    {
      style: "viewtable",
      height: "h54vh",
      footer: false,
      setPageSize: handlePageSizeChange,
      pageSize: pageSize,
      rowCount: rowCount,
      handlePageChange: handlePageChange,
      page: page,
      paginationMode: "server",
    },
  ];

  // const navigate = useNavigate();

  const startIndex = onPage * pageSize;
  const rows =
    displayData?.map((d, i) => ({
      id: d.id ? d.id : "N/A",
      srno: startIndex + i + 1,
      exam_name: d.exam_name ? d.exam_name : "N/A",
      exam_code: d.exam_code ? d.exam_code : "N/A",
      center_code: d.center?.map((cen) => cen?.center_code).join(", ") || "N/A",
      course_name: d.course?.length
        ? d.course?.map((cou) => cou?.course_name).join(", ")
        : "N/A",
      questions: d.question_count ? d.question_count : "N/A",
      duration: d.duration ? d.duration : "N/A",
      total_score: d.total_score ? d.total_score : "N/A",
      start_date: d.start_date ? d.start_date : "N/A",
      start_time: d.start_time ? d.start_time : "N/A",
      active_status: d.active_status ? d.active_status : "N/A",
    })) || [];

  const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 11,
    },
  }))(Tooltip);

  const handleButtonClickQuestion = (type, rowId, score) => {
    navigate(`/admin/${type}/${rowId}`, { state: score });
  };



  const columns = [
    {
      field: "srno",
      headerName: "#",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 70,
      // flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "exam_code",
      headerName: "Exam Code",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 110,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "exam_name",
      headerName: "Exam Name",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 110,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "center_code",
      headerName: "Branch Code",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 110,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "questions",
      headerName: "No. Of Questions",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 200,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "duration",
      headerName: "Duration",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 110,
      flex: 1,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    {
      field: "start_date",
      headerName: "Start Date",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      flex: 1,
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
      renderCell: (cellValues) => (
        <div>
          {new Date(cellValues.row.start_date).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "2-digit",
          })}
        </div>
      ),
    },
    {
      field: "start_time",
      headerName: "Start Time",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      width: 100,
      sortable: false,
      disableColumnMenu: true,
      autoPageSize: false,
    },
    // {
    //   field: "status",
    //   headerName: "Status",
    //   headerClassName: "super-app-theme--header",
    //   headerAlign: "center",
    //   sortable: false,
    //   disableColumnMenu: true,
    //   width: 150,
    //   autoPageSize: false,
    //   renderCell: (cellValues) => {
    //     const isActive = cellValues.row.active_status === "active";
    //     return (
    //       <div
    //         className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter} ${classes.mr1}`}
    //       >
    //         <IconButton
    //           className={`${classes.w15}`}
    //           aria-describedby={id}
    //           onClick={(event) => {
    //             handleClick(event, cellValues.row.id);
    //           }}
    //         >
    //           <ArrowLeftIcon fontSize="small" />
    //         </IconButton>
    //         <Typography
    //           className={`${classes.dflex} ${classes.alignitemscenter}`}
    //           variant="h6"
    //         >
    //           {/* {isActive ? <ActiveIcon /> : <InactiveIcon fontSize="small" />} */}
    //           <ActiveIcon />
    //           {cellValues.row.active_status}
    //         </Typography>
    //         <Popover
    //           id={id}
    //           open={popoveropen && selectedRowId === cellValues.row.id}
    //           anchorEl={anchorEl}
    //           onClose={handleClose}
    //           anchorOrigin={{
    //             vertical: "center",
    //             horizontal: "left",
    //           }}
    //           transformOrigin={{
    //             vertical: "center",
    //             horizontal: "right",
    //           }}
    //         >
    //           <Paper>
    //             <IconButton
    //               // onClick={(event) => {
    //               //   handleStatus(
    //               //     cellValues.row.id,
    //               //     cellValues.row.active_status
    //               //   );
    //               // }}
    //             >
    //               <LightTooltip title="Disable">
    //                 <VisibilityOffOutlinedIcon />
    //               </LightTooltip>
    //             </IconButton>
    //             <IconButton
    //               // onClick={() => {
    //               //   handleButtonClick("editquizz", cellValues.row.id);
    //               // }}
    //             >
    //               <LightTooltip title="Edit">
    //                 <SettingsIcon />
    //               </LightTooltip>
    //             </IconButton>
    //             <IconButton>
    //               <LightTooltip title="Delete">
    //                 <DeleteIcon
    //                   // onClick={() => deleteDataOfRow(cellValues.row.id)}
    //                 />
    //               </LightTooltip>
    //             </IconButton>
    //           </Paper>
    //         </Popover>
    //       </div>
    //     );
    //   },
    // },

    {
      field: "action",
      headerName: "Action",
      headerClassName: "super-app-theme--header",
      headerAlign: "center",
      sortable: false,
      disableColumnMenu: true,
      width: 150, // Reduced width since we have fewer icons
      renderCell: (params) => {
        return (
          <div
            className={`${classes.dflex} ${classes.alignitemscenter} ${classes.justifycenter}`}
            style={{ gap: "12px", width: "100%" }}
          >
            {/* Dashboard Button */}
            <IconButton
              onClick={() => {   handleButtonClickQuestion("examdashboard", params.row.id); }}
              style={{
                backgroundColor: "#f0f7ff", // Very light blue background
                padding: "8px",
              }}
              className={classes.boxshadow1} // Using your existing shadow class
            >
              <LightTooltip title="Dashboard">
                <DashboardIcon style={{ color: "#007bff", fontSize: "1.2rem" }} />
              </LightTooltip>
            </IconButton>

            {/* Result Button */}
            {/* <IconButton
              onClick={() => {   handleButtonClickQuestion("examresult", params.row.id); }}
              style={{
                backgroundColor: "#f0fff4", // Very light green background
                padding: "8px",
              }}
              className={classes.boxshadow1}
            >
              <LightTooltip title="Result">
                <ResultIcon style={{ color: "#28a745", fontSize: "1.2rem" }} />
              </LightTooltip>
            </IconButton> */}
          </div>
        );
      },
    },
  ];

  const row = [
    {
      id: 1,
      subject: "History of united nation",
      examname: "SBI CLERK 2024 | Speed Maths 25 Question",
      assigned: "Amar Sir",
      students: "28",
      active_status: "Taken",
    },
    {
      id: 2,
      subject: "History of united nation",
      examname: "SBI CLERK 2024 | Speed Maths 25 Question",
      assigned: "Amar Sir",
      students: "28",
      active_status: "Taken",
    },
    {
      id: 3,
      subject: "History of united nation",
      examname: "SBI CLERK 2024 | Speed Maths 25 Question",
      assigned: "Amar Sir",
      students: "28",
      active_status: "Taken",
    },
  ];
  return (
    <div
      className={`${classes.mt1_5} ${classes.bgwhite} ${classes.p0_5}  ${classes.boxshadow1} ${classes.borderradius6px}`}
    >
      <div
        className={`${classes.dflex} ${classes.justifyspacebetween} ${classes.alignitemscenter}`}
      >
        <Typography
          className={`${classes.my1} ${classes.fontfamilyoutfit} ${classes.fontsize5} ${classes.fw700}`}
        >
          Today's Scheduled
        </Typography>
        <Button
          className={`${classes.viewallbtn}`}
          onClick={() => navigate(`/admin/exam`)}
        >
          View All <KeyboardArrowRightIcon style={{ fontSize: "medium" }} />
        </Button>
      </div>
      <TableView columns={columns} rows={rows} Heading={style} />
    </div>
  );
}

export default UpcomingExam;
